import { render, staticRenderFns } from "./Artshare.vue?vue&type=template&id=0be947aa"
import script from "./Artshare.vue?vue&type=script&lang=js"
export * from "./Artshare.vue?vue&type=script&lang=js"
import style0 from "./Artshare.vue?vue&type=style&index=0&id=0be947aa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports